<template>
    <div class="container">
        <!--form-->
        <el-form size="mini" :inline="true" label-position="left" :label-width="queryFormLabelWidth" :model="queryForm" ref="queryForm">
            <el-form-item label="学校名称" prop="commercial_id" v-if="autocompleteData.schoolsList.length > 0">
                <el-autocomplete
                    v-model="autocompleteData.school_name"
                    clearable
                    value-key="school_name"
                    placeholder="请输入"
                    :trigger-on-focus="false"
                    :fetch-suggestions="(query, cb) => querySchoolSearch(query, cb, 'schoolsList')"
                    @clear="clearSelect('schoolsList', 2)"
                    @select="(item)=>handleSelect(item, 'schoolsList')">
                </el-autocomplete>
            </el-form-item>
            <el-form-item label="店铺名称" prop="shop_id" v-if="autocompleteData.shopsList.length > 0">
                <el-autocomplete
                    v-model="autocompleteData.shop_name"
                    clearable
                    value-key="shop_name"
                    placeholder="请输入"
                    :trigger-on-focus="false"
                    :fetch-suggestions="(query, cb) => querySchoolSearch(query, cb, 'shopsList')"
                    @clear="clearSelect('shopsList', 2)"
                    @select="(item)=>handleSelect(item, 'shopsList')">
                </el-autocomplete>
            </el-form-item>
            <el-form-item label="下单日期" prop="dateType">
                <el-date-picker
                    class="fl ml10"
                    v-model="queryForm.dateRange"
                    type="daterange"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    placeholder="请选择日期"
                    :picker-options="pickerOptions">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="fetchData">查询</el-button>
                <el-button @click="resetForm">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="line"></div>
        <el-row class="pb20">
          <div class="doing">友情提示：只能查询此功能上线之后(9月10号)的数据</div>
        </el-row>
        <el-table
            v-loading="loading"
            :data="tableData"
            border
            style="width: 100%">
            <el-table-column
                v-for="(item, index) in tableColumn"
                :prop="item.id"
                :label="item.name"
                :show-overflow-tooltip="true"
                :key="index"
                :width="item.width"
                :fixed="item.fixed">
                <template slot-scope="scope">
                    <span v-if="item.formatter">{{ item.formatter(scope.row) }}</span>
                    <span v-else>
                        {{ scope.row[item.id] }}
                        <span v-if="item.unit">{{item.unit}}</span>
                    </span>
                </template>
            </el-table-column>
        </el-table>
        <!--<div class="red pb10 mt20">曝光人次、入店人次、下单人次：不管以何种形式在客户端（所有端口）操作都计入，一个自然小时内只计算一次</div>-->
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryForm.pageNo"
            :page-sizes="pageSizes"
            :page-size="queryForm.pageSize"
            layout="total, sizes, prev, pager, next"
            :total="total">
        </el-pagination>
    </div>
</template>

<script>
import { getSchoolAndShop } from '~/mixins/getSchoolAndShop';
import moment from 'moment';

export default {
    name: "flowList",
    mixins: [ getSchoolAndShop ],
    data() {
        let vue = this;
        return {
            timeOptionRange: null,
            pickerOptions: {
                // disabledDate(time) {
                //     let timeOptionRange = vue.timeOptionRange;
                //     let secondNum = 60*60*24*7*1000;
                //     if(timeOptionRange){
                //         return time.getTime() > timeOptionRange.getTime() + secondNum || time.getTime() < timeOptionRange.getTime() - secondNum ;
                //     }
                // },
                // onPick(time){ //当第一时间选中才设置禁用

                //     if(time.minDate && !time.maxDate){
                //         vue.timeOptionRange = time.minDate;
                //     }
                //     if(time.maxDate){
                //         vue.timeOptionRange = null;
                //     }
                // }
            },
            queryFormLabelWidth: '100px',//自定义查询表单label宽度
            payWayName: '',
            queryForm: {//查询表单数据
                pageSize: 10,
                pageNo: 1,
                dateRange: [],
            },
            total: 0,//总数
            pageSizes: [10,20,30,40,50],//自定义分页条数
            tableColumn: [
                { name: '学校名称', id: 'schoolName', fixed: false },
                { name: '店铺名称', id: 'shopName', fixed: false },
                { name: '曝光人次', id: 'viewCount', fixed: false, width: '100' },
                { name: '入店人次', id: 'enterCount', fixed: false, width: '100' },
                { name: '入店转化率', id: 'enterConversion', fixed: false, width: '90', unit: '%' },
                { name: '下单人次', id: 'orderCount', fixed: false, width: '100' },
                { name: '下单转化率', id: 'orderConversion', fixed: false, width: '90', unit: '%' },
            ],
            loading: false,
            tableData: [],
        }
    },
    created(){
        //默认显示最近一周
        if(this.$route.query.date){
            let temp = [];
            temp = this.$route.query.date.split('-');
            this.queryForm.dateRange = [new Date(temp[0],temp[1]-1,temp[2]),new Date(temp[1],temp[1]-1,temp[2])];
        }else{
            let day = new Date();
            day.setTime(day.getTime()-7*24*60*60*1000);
            this.queryForm.dateRange = [day,new Date()];
        }
    },
    mounted() {
        this.fetchData();
    },
    methods: {
        /** 切换每页显示条数操作 */
        handleSizeChange(val) {
            this.queryForm.pageSize = val;
            this.fetchData();
        },
        /** 切换页码操作 */
        handleCurrentChange(val) {
            this.queryForm.pageNo = val;
            this.fetchData();
        },
        /** 重置 */
        resetForm () {
            let day = new Date();
            day.setTime(day.getTime()-7*24*60*60*1000);
            this.queryForm.dateRange = [day,new Date()];
            this.queryForm.pageNo = 1;
            this.queryForm.pageSize = 10;
            this.autocompleteData.school_id = '';
            this.autocompleteData.shop_id = '';
            this.fetchData();
        },
        /** 获取列表 */
        fetchData() {
            let params = {
                pageSize: this.queryForm.pageSize,
                pageNo: this.queryForm.pageNo,
                schoolId: this.autocompleteData.school_id, // 学校名称
                shopId: this.autocompleteData.shop_id, // 门店名称
                beforeDate: moment(this.queryForm.dateRange[0]).format('YYYY-MM-DD'), // 起始时间
                afterDate: moment(this.queryForm.dateRange[1]).format('YYYY-MM-DD'), // 结束时间
            };

            this.$apiJava.post(this.$apiUrl.commercialGdShopAmount, params,(res)=>{
                if (res.message == "success" && res.result && res.data) {
                    this.total = res.data.total;
                    this.tableData = res.data.list;
                } else {
                    this.total = 0;
                    this.tableData = [];
                    this.$message.warning(res.message);
                }
            },(res)=>{
                this.total = 0;
                this.tableData = [];
                this.$message.warning(res.message);
            },'gc')

        }
    }
}
</script>

<style scoped>
    .mt20 {
        margin-top: 20px;
    }
    .doing {
      /*text-align: center;*/
      /*font-size: 20px;*/
      /*line-height: 28px;*/
      color: #da0b1f;


      font-size: 14px;
      line-height: 15px;
    }
</style>


// WEBPACK FOOTER //
// list.vue?f33d2c2c